export function reverseCompassDirection(degrees) {
  return (parseInt(degrees) + 180) % 360;
}
